import { render, staticRenderFns } from "./thankPage.vue?vue&type=template&id=bbc8d304&"
import script from "./thankPage.vue?vue&type=script&scoped=true&lang=js&"
export * from "./thankPage.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./thankPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports